<template>
  <div class="column-multline" style="font-weight: normal">
    <div class="btns-actions" v-if="consultaNaoConfirmada">
      <confirmar-cancelar-consulta :agenda="row" @success="click"/>
      <div style="margin: 10px 0" v-if="possuiPendencias">
        <el-button @click="gotoPendencias()" class="btn" style="background-color: #E8AA00; color:#FFFFFF; font-weight: normal;">
          <inline-svg style="vertical-align: bottom;" :src="require('@/assets/icons/icon_mini_info.svg')" />
          Pendências a resolver
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ConfirmarCancelarConsulta from '@/views/53/components/ConfirmarCancelarConsulta.vue'
import inlineSvg from 'vue-inline-svg'

export default {
  name: 'AcoesMinhasConsultas',
  components: { inlineSvg, ConfirmarCancelarConsulta },
  props: ['column', 'row'],
  computed: {
    consultaNaoConfirmada () {
      return this.row.configuracoes.agendaConfirmada === false && this.row.configuracoes.solicitaConfirmacao
    },
    possuiPendencias () {
      return (
        this.row.tipoAgenda === '2' &&
        this.row.meeting &&
        this.row.meeting.responsavelAtendimento &&
        this.row.meeting.responsavelAtendimento.pendencias &&
        Object.values(this.row.meeting.responsavelAtendimento.pendencias).some(item => item.valor === false)
      )
    }
  },
  methods: {
    gotoPendencias () {
      this.$router.push({ path: '/53/pendencias', query: { idAgenda: this.row.idAgenda } })
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lange="less">
.btns-actions > div{
  display: flex;
  align-items: center;
  :nth-child(1) {
    margin-right: 8px;
  }
}
</style>
